import React from 'react';
import factory from 'components/Icons/factory';

export const Mail = factory(
  'Mail',
  <path
    d="M127,27.4v71.1c0,1.2-0.3,2.4-0.8,3.4L84.8,63l41.3-39C126.7,25.1,127,26.2,127,27.4L127,27.4z M119.6,20
	c1.1,0,2,0.2,2.9,0.6l-53,50.1c-3,2.8-8,2.8-11,0L5.4,20.6c0.9-0.4,1.9-0.6,3-0.6H119.6z M1.8,101.9c-0.5-1-0.8-2.2-0.8-3.4V27.4
	C1,26.2,1.3,25,1.9,24l41.3,39L1.8,101.9L1.8,101.9z M8.4,106c-1.1,0-2-0.2-2.9-0.6l41.3-39l8.4,7.9c2.5,2.3,5.7,3.5,8.9,3.5
	c3.2,0,6.4-1.2,8.8-3.5l8.4-7.9l41.3,39c-0.9,0.4-1.9,0.6-2.9,0.6H8.4L8.4,106z"
  />
);

export default Mail;
